import React from 'react'
import LpEmbassyHead from './LpEmbassyHead'
import LpEmbassyMain from './LpEmbassyMain'

const LpEmbassy = () => {
  return (
    <div className='lpEmbassy-container'>
      <LpEmbassyHead/>
      <LpEmbassyMain/>
    </div>
  )
}

export default LpEmbassy
